<template>
    <div class="area">
        <div>
            <div class="gameRecordTitle">{{$t('activationRecord.title')}}</div>
            <div class="textOne">{{$t('activationRecord.text1')}}</div>

            <el-form ref="form" :model="form">
                <el-form-item :label="$t('activationRecord.text2')" class="actName">
                    <el-input v-model="form.actName" :placeholder="$t('activationRecord.text3')"></el-input>
                </el-form-item>
                
                <el-form-item :label="$t('activationRecord.text4')" class="record">
                    <div class="inputWidth">
                        <el-date-picker
                            type="date"
                            :editable="false"
                            :placeholder="$t('record.text1')"
                            v-model="form.dateBegin"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 100%;"></el-date-picker>
                            <i class="timeIcon"></i>
                    </div>
                    <el-col class="line" :span="1"></el-col>
                    <div class="inputWidth">
                        <el-date-picker
                            type="date"
                            :editable="false"
                            :placeholder="$t('record.text1')"
                            v-model="form.dateEnd"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 100%;"></el-date-picker>
                            <i class="timeIcon"></i>
                    </div>
                    <div class="button">
                        <span class="query" @click="query(1)">{{$t('record.text2')}}</span>
                        <span class="reset" @click="reset">{{$t('record.text3')}}</span>
                    </div>
                </el-form-item>

            </el-form>


            <el-table :data="tableData" style="width: 100%" height="430" v-show="tableData.length > 0">
                <el-table-column prop="actName" :label="$t('activationRecord.text5')" align="center"></el-table-column>
                <el-table-column prop="joinTime" :label="$t('activationRecord.text6')" align="center"></el-table-column>
                <el-table-column :label="$t('activationRecord.text7')" align="center">
                    <template slot-scope="scope">
                        <p type="text" size="small" @click="checkDetails(scope)" class="cursorPoint" style="color:#E91919;">{{$t('activationRecord.text8')}}</p>
                    </template>
                </el-table-column>
            </el-table>

            <div class="null" v-show="tableData.length === 0" style="height:430px;max-height: 430px;">
                <img loading="lazy" class="nullImg" v-lazy="require('../../../assets/images/xf/null.png')" alt="">
                <p class="nullText">{{$t('record.text4')}}</p>
            </div>

            <div class="borderBottom"></div>

            <div class="pagination">
                <el-pagination small layout="prev, pager, next" :pageSize="10" @current-change="query" :total="total" :current-page.sync="currentPage"></el-pagination>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            key: 'value',
            form: {
                actName: '',
                dateBegin: '',
                dateEnd: '',
                pageSize: 10,
                currentPage: '',
                memberId: this.$common.getUser().user_id,
            },
            total: 1,
            currentPage: 1,
            tableData: [],
        }
    },
    created() {
        this.query(1);
    },
    methods: {
        reset() {
            this.form.dateBegin = '';
            this.form.dateEnd = '';
            this.form.actName = '';
        },
        checkDetails(scope){
            this.$router.push("/discount?id=" + scope.row.activityId);
        },
        // 查询列表数据
        query(val = 1) {
            let that = this;
            let data = {...that.form};
            data.currentPage = val;
            data.dateBegin?data.dateBegin = `${data.dateBegin} 00:00:00`:'';
            data.dateEnd?data.dateEnd = `${data.dateEnd} 23:59:59`:'';
            that.currentPage = val;
            that.$http.post(that.$api.getPartake, data, true).then((res) => {
                if (res && res.data) {
                    if(res.data.totalRecords > 0){
                        res.data.content.map((item) => {
                            item.joinTime = that.$common.conversionTime(item.joinTime);
                        });
                        that.tableData = res.data.content;
                        if (res.data.totalRecords > 10) {
                            that.total = res.data.totalRecords;
                        } else {
                            that.total = 0;
                        }
                    }else{
                        that.tableData = [];
                        that.total = 0;
                    }
                } else {
                    that.tableData = [];
                    that.total = 0;
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
@import url('./record.css');
.el-form-item{
    margin-bottom: 37px;
}
.actName .el-input{
    width: 660px !important;
}
.line{
    width: 20px;
    height: 1px;
    border-top: 1px solid #313131;
    margin: 0 10px;
}
.copybutton {
    border: none;
    color:#E91919;
    background: none;
    padding: 0 5px;
    font-size: 0.14rem !important;
    padding-top: 0.02rem;

}
.betNo{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 1.3rem;
    font-size: 0.14rem !important;
}
.borderBottom{
    height: 1px;
    background: #CDD8E0;
    margin-top: 23px;
}

.pagination{
    width: 100%;
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
}
</style>